import DisplayAppropriateReport from "../../Shared/Report/DisplayAppropriateReport";

export default function ViewReferredStatus() {
  return <DisplayAppropriateReport reportType={"referredDetail"} department={'eic'} />;
}
